module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAuElEQVQ4T6XSwREBQRBG4U8GMkAmSiRcHJycnYgAVe5kgAzIQAhCkAHValaxFrNlLnPpef16/m748zT+fK8uYIoLFkXjXEAXa+xRQO6MX4A25uhgjEN55G+A6NRPug/lHEChe0xdY+aPp2ywQg+jKt0qShkwxCTNvcyJuOoPmtighQFOdUZ4ro2/CNAWs5T/G+tXjGET8UUace9yUqgyjn0Im2sa61x3E4v6MAmr2qucvQc5yb3U3AB9NRsRLIqPdQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left.png
// module id = fGwC
// module chunks = 1